import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-gadget-listing';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling Gadgets on eBay? Here Are The Simple Yet Best Ways To Do It</title>
        <meta
          name='description'
          content='Listing in-demand items like electronics on marketplaces go beyond posting photos. From creating titles and structured descriptions to setting up price points, here is the effective approach to do it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-gadget-listing' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-gadget-listing' />
        <meta property='og:title' content='Selling Gadgets on eBay? Here Are The Simple Yet Best Ways To Do It' />
        <meta
          property='og:description'
          content='Listing in-demand items like electronics on marketplaces go beyond posting photos. From creating titles and structured descriptions to setting up price points, here is the effective approach to do it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
